import { useEffect, useState } from 'react';

// Cross-fading phone screenshots — loops every 2.6s.
export default function AppLoop() {
  const [i, setI] = useState(0);
  useEffect(() => {
    const id = setInterval(() => setI((x) => (x + 1) % 2), 2600);
    return () => clearInterval(id);
  }, []);

  const srcs = ['/assets/app_1.jpeg', '/assets/app_2.jpeg'];
  const imgStyle = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    height: '100%',
    width: 'auto',
    maxWidth: 'none',
    display: 'block',
    transition: 'opacity 500ms ease',
  };

  return (
    <>
      {srcs.map((s, idx) => (
        <img
          key={s}
          src={s}
          alt={`App PixViewer ${idx + 1}`}
          style={{ ...imgStyle, opacity: i === idx ? 1 : 0 }}
        />
      ))}
    </>
  );
}
